import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flashmessage", _ctx.flashClass])
  }, [
    _createTextVNode(_toDisplayString(_ctx.message.text) + " ", 1),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}